import React from "react";

import Styles from "./styles/studentDetailsCard.module.scss";
import styled from "styled-components";
import { Modal, Progress } from "antd";
import moment from "moment";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { progressBarColor } from "../../../../utils/commonFunctions";

export const Label = styled.p`
  font-family: "Basis Grotesque Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 21px;

  color: #939599;
`;

export const Details = styled.p`
  font-family: "Basis Grotesque Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height, or 150% */

  color: #1e2228;
`;

const ImageContainer = styled.div`
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 0;
  }
`;
const ContentContainer = styled.div`
  width: 80%;

  @media (max-width: 768px) {
    width: 90%;
  }
`;

const MainContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

const Skills = ({ skillsList }) => (
  <div style={{ flex: 1, margin: "20px 0" }}>
    <p
      style={{
        color: "#FF2C91",

        fontFamily: "Basis Grotesque Pro",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "21px",
        marginBottom: "20px",
      }}
    >
      Skill Proficiency
    </p>
    <div
      style={{
        display: "grid",

        gridTemplateColumns: "18% 18% 18% 18% 18%",
        gridGap: "3%",
      }}
    >
      {skillsList?.map(({ skills, top_percentile, percentile }) => {
        return (
          <div>
            <p
              style={{
                color: "#1E2228",

                fontFamily: "Basis Grotesque Pro",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: "14px",
                lineHeight: "21px",
              }}
            >
              <EllipsisWithTooltip placement="bottom">
                {skills}
              </EllipsisWithTooltip>
            </p>
            <Progress
              strokeColor={progressBarColor(percentile)}
              percent={percentile}
              showInfo={false}
            />
            <p
              style={{
                color: "#1E2228",

                fontFamily: "Basis Grotesque Pro",
                fontStyle: "normal",
                fontWeight: "400",
                fontSize: "12px",
                fontWeight: "600",
                lineHeight: "21px",
              }}
            >
              Top {top_percentile}%
            </p>
          </div>
        );
      })}
    </div>
  </div>
);
export const StudentDetails = ({
  onClose,
  open,
  studentDetails,
  skillsList,

}) => {
  return (
    <Modal
      width="900px"
      className={`studentDetails`}
      visible={open}
      header={false}
      footer={false}
      onCancel={onClose}
    >
      <div className={Styles.innerContainer}>
        <MainContainer>
          <ImageContainer>
            <img
              src={studentDetails?.profile_image}
              style={{ marginRight: "40px" }}
              className={`${Styles["image-inner"]} ${Styles.imageadjust} ${Styles.hideInMobile}`}
            />
          </ImageContainer>
          <ContentContainer>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <img
                src={studentDetails?.profile_image}
                style={{ marginRight: "40px" }}
                className={`${Styles["image-inner1"]} ${Styles.imageadjust1} ${Styles.showInMobile}`}
              />
              <div>
                <h3
                  style={{
                    fontFamily: "Basis Grotesque Pro",
                    fontStyle: "normal",
                    fontWeight: "700",
                    fontSize: "18px",
                    lineHeight: "21px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {studentDetails?.name}
                </h3>
                <p
                  style={{
                    fontFamily: "Basis Grotesque Pro",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "21px",
                    color: "#939599",
                  }}
                >
                  {studentDetails?.location && (
                    <>
                      <img src="/location.svg" style={{ marginRight: "5px" }} />
                      {studentDetails?.location} |
                    </>
                  )}&nbsp;
                 {studentDetails?.experience_month ? `${Math.floor(studentDetails?.experience_month / 12)?`${Math.floor(studentDetails?.experience_month / 12)} yrs`:""} 
                  ${studentDetails?.experience_month
                    ? `${studentDetails?.experience_month % 12} mos`
                    : ""}
                  exp.`:""}
                </p>
              </div>
            </div>

            <Skills
              skillsList={skillsList}
            />
            <div
              style={{
                marginTop: "20px",
                display: "grid",

                gridTemplateColumns: "22% 22% 22% 22%",
                gridGap: "2rem",
              }}
            >
              <div>
                <Label>Current Company</Label>
                <Details>
                  {studentDetails?.company_name
                    ? studentDetails.company_name
                    : "-"}
                </Details>
              </div>
              <div>
                <Label>College</Label>
                <Details>
                  {studentDetails?.college ? studentDetails?.college : "-"}
                </Details>
              </div>
              <div>
                <Label>Degree</Label>
                <Details>
                  {studentDetails?.degree ? studentDetails?.degree : "-"}
                </Details>
              </div>
              <div>
                <Label>Other Skills</Label>
                <Details>{studentDetails?.otherskills? studentDetails?.otherskills:" - "}</Details>
              </div>
              <div>
                <Label>Curent CTC</Label>
                <Details>
                  {studentDetails?.current_salary || "-"}
                </Details>
              </div>
              <div>
                <Label>Expected CTC</Label>
                <Details>
                  {studentDetails?.expected_salary || "-"}
                </Details>
              </div>
              <div>
                <Label>Notice Period</Label>
                <Details>
                  {studentDetails?.notice_period || "-"}
                </Details>
              </div>
              <div>
                <Label>Available ON</Label>
                <Details>
                  {studentDetails?.available_on ? moment(studentDetails?.available_on).format("MMMM Do YYYY") : '-'}
                </Details>
              </div>
            </div>
          </ContentContainer>
        </MainContainer>
      </div>
    </Modal>
  );
};

export default StudentDetails;
